<template>
  <ImageButtonCheck
    v-model="proxyValue"
    :imgSrc="require('@/assets/images/Building.svg')"
    :text="$t('In-person')"
  />
</template>

<script>

import { defineComponent } from 'vue';
import ImageButtonCheck from '@/components/buttons/imageButtonCheck.vue';


export default defineComponent({
  name: 'InPersonButton',
  components: {
    ImageButtonCheck,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    proxyValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>

<style scoped></style>
